import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { datadogRum } from '@datadog/browser-rum';

// Datadog RUM/Session Replay: habilitado SOMENTE em produção.
// Em dev/homolog (REACT_APP_ENV != "production") não inicializa.
if (process.env.REACT_APP_ENV === "production") {
  datadogRum.init({
    applicationId: '858f4e5d-3a1b-4852-a4a4-e87bb65e32a7',
    clientToken: 'pubfa0f2674accadb924897805c92957439',
    site: 'datadoghq.com',
    service: 'crm-hub',
    env: 'prod',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    defaultPrivacyLevel: 'allow',
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
  });
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root"),
);
reportWebVitals();
